export const getSafeInternalRedirectPath = (path: string | null): string | undefined => {
  if (!path || !path.startsWith('/') || path.startsWith('//')) {
    return undefined;
  }

  try {
    const url = new URL(path, window.location.origin);
    return url.origin === window.location.origin ? path : undefined;
  } catch {
    return undefined;
  }
};
